import { TINTS } from '../lib/tints';

export const SwatchRow = ({ value, onChange, testIdPrefix, size = 'sm' }) => {
  const dim = size === 'lg' ? 'h-7 w-7' : 'h-4 w-4';
  return (
    <div className="flex items-center justify-center gap-1" data-testid={`${testIdPrefix}-swatches`}>
      {TINTS.map((t) => {
        const active = t.id === value;
        return (
          <button
            key={t.id}
            type="button"
            data-testid={`${testIdPrefix}-swatch-${t.id}`}
            aria-label={`${t.label} colour`}
            aria-pressed={active}
            title={t.label}
            onPointerDown={(e) => e.stopPropagation()}
            onClick={(e) => { e.stopPropagation(); onChange(t.id); }}
            className={`${dim} rounded-full border-2 border-ink transition-transform hover:scale-110 ${
              active ? 'ring-2 ring-ink ring-offset-1 ring-offset-paper scale-110' : ''
            }`}
            style={{ backgroundColor: t.hex }}
          />
        );
      })}
    </div>
  );
};
